import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../../../../components/mui/Styles/index'
import { Grid, Paper } from '../../../../../components/mui/Core/index'
import LinkButton from '../../../../../components/LinkButton/link-button'
import { setSelectedInventoryItem } from '../../../Inventory/inventory-slice'
import * as Constants from '../../../../../constants/en.json'

export function GroupSpecialPricingTable() {
  const theme = useTheme()
  const customerSpecialPricing = useSelector((state) => state.customerGroup.customerSpecialPricing)
  const isFetchingCustomerSpecialPricing = useSelector(
    (state) => state.customerGroup.isFetchingCustomerSpecialPricing,
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const gridStyle = {
    minHeight: '160px',
    height: isFetchingCustomerSpecialPricing ? '400px' : 'auto',
    backgroundColor: theme.palette.common.white,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
    '& .MuiDataGrid-cell': {
      paddingRight: '25px',
    },
  }

  const rows = customerSpecialPricing.map((row) => ({
    id: row.itemNumber,
    itemNumber: row.itemNumber,
    itemDescription: row.itemDescription,
    wacListPrice: row.wacListPrice,
    quantity: row.quantity,
    uom: row.uom,
    liveQuantity: row.liveQuantity,
  }))

  const handleItemLinkClick = (itemNumber) => {
    dispatch(setSelectedInventoryItem(itemNumber))
    navigate('/itemDetails')
  }

  const columns = [
    {
      field: 'itemNumber',
      headerName: Constants.groupSpecialPricing.NDC_ITEM,
      sortable: true,
      flex: 0.2,
      minWidth: 200,
      renderCell: (cellValues) => {
        return (
          <LinkButton
            handleLinkClick={() => {
              handleItemLinkClick(cellValues.row)
            }}
            linkText={cellValues.row.itemNumber}
          />
        )
      },
    },
    {
      field: 'itemDescription',
      headerName: Constants.groupSpecialPricing.ITEM_DESCRIPTION,
      sortable: false,
      flex: 0.3,
      minWidth: 250,
    },
    {
      type: 'number',
      field: 'wacListPrice',
      headerName: Constants.groupSpecialPricing.UNIT_PRICE,
      headerAlign: 'right',
      align: 'right',
      flex: 0.2,
      minWidth: 150,
      sortable: false,
      valueFormatter: (value) => {
        const unitPrice = value
        return `$${unitPrice}`
      },
    },
  ]

  return (
    <Grid sx={{ paddingTop: 3 }}>
      <Paper>
        <DataGrid
          sx={gridStyle}
          rows={rows}
          columns={columns}
          loading={isFetchingCustomerSpecialPricing}
          pageSizeOptions={[25, 50]}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
          slotProps={{
            pagination: {
              component: 'div',
              showLastButton: true,
              showFirstButton: true,
            },
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
        />
      </Paper>
    </Grid>
  )
}

export default GroupSpecialPricingTable
